const primeRates = [
    {
        score: 550,
        rates: [
            { limit: 0, rate: 12.9 },
            { limit: 7500, rate: 12.9 },
            { limit: 10000, rate: 12.9 },
            { limit: 15000, rate: 11.9 },
            { limit: 20000, rate: 10.9 },
            { limit: 30000, rate: 9.9 },
            { limit: 40000, rate: 9.9 },
            { limit: 50000, rate: 8.9 },
            { limit: 100000, rate: 8.9 }
        ]
    },
    {
        score: 525,
        rates: [
            { limit: 0, rate: 13.9 },
            { limit: 7500, rate: 13.9 },
            { limit: 10000, rate: 12.9 },
            { limit: 15000, rate: 11.9 },
            { limit: 20000, rate: 10.9 },
            { limit: 30000, rate: 9.9 },
            { limit: 40000, rate: 9.9 },
            { limit: 50000, rate: 8.9 },
            { limit: 100000, rate: 8.9 }
        ]
    },
    {
        score: 500,
        rates: [
            { limit: 0, rate: 14.9 },
            { limit: 7500, rate: 13.9 },
            { limit: 10000, rate: 12.9 },
            { limit: 15000, rate: 11.9 },
            { limit: 20000, rate: 10.9 },
            { limit: 30000, rate: 9.9 },
            { limit: 40000, rate: 9.9 },
            { limit: 50000, rate: 8.9 },
            { limit: 100000, rate: 8.9 }
        ]
    },
    {
        score: 475,
        rates: [
            { limit: 0, rate: 14.9 },
            { limit: 7500, rate: 14.9 },
            { limit: 10000, rate: 13.9 },
            { limit: 15000, rate: 12.9 },
            { limit: 20000, rate: 11.9 },
            { limit: 30000, rate: 9.9 },
            { limit: 40000, rate: 9.9 },
            { limit: 50000, rate: 9.9 },
            { limit: 100000, rate: 8.9 }
        ]
    },
    {
        score: 425,
        rates: [
            { limit: 0, rate: 15.9 },
            { limit: 7500, rate: 14.9 },
            { limit: 10000, rate: 14.9 },
            { limit: 15000, rate: 13.9 },
            { limit: 20000, rate: 12.9 },
            { limit: 30000, rate: 10.9 },
            { limit: 40000, rate: 10.9 },
            { limit: 50000, rate: 9.9 },
            { limit: 100000, rate: 8.9 }
        ]
    },
    {
        score: 350,
        rates: [
            { limit: 0, rate: 15.9 },
            { limit: 7500, rate: 15.9 },
            { limit: 10000, rate: 15.9 },
            { limit: 15000, rate: 14.9 },
            { limit: 20000, rate: 12.9 },
            { limit: 30000, rate: 10.9 },
            { limit: 40000, rate: 10.9 },
            { limit: 50000, rate: 9.9 },
            { limit: 100000, rate: 8.9 }
        ]
    },
    {
        score: 0,
        rates: [
            { limit: 0, rate: 15.9 },
            { limit: 7500, rate: 15.9 },
            { limit: 10000, rate: 15.9 },
            { limit: 15000, rate: 14.9 },
            { limit: 20000, rate: 12.9 },
            { limit: 30000, rate: 10.9 },
            { limit: 40000, rate: 10.9 },
            { limit: 50000, rate: 9.9 },
            { limit: 100000, rate: 8.9 }
        ]
    }
];

const primeRatesCtMandCkDirect = [
    {
        score: 375, // and above
        rates: [
            { limit: 0, rate: 12.9 },
            { limit: 7500, rate: 12.9 },
            { limit: 10000, rate: 11.9 },
            { limit: 15000, rate: 11.9 },
            { limit: 20000, rate: 10.9 },
            { limit: 30000, rate: 9.9 },
            { limit: 40000, rate: 9.9 },
            { limit: 50000, rate: 8.9 },
            { limit: 100000, rate: 8.9 }
        ]
    },
    {
        score: 0,
        rates: [
            { limit: 0, rate: 15.9 },
            { limit: 7500, rate: 15.9 },
            { limit: 10000, rate: 15.9 },
            { limit: 15000, rate: 14.9 },
            { limit: 20000, rate: 12.9 },
            { limit: 30000, rate: 10.9 },
            { limit: 40000, rate: 10.9 },
            { limit: 50000, rate: 9.9 },
            { limit: 100000, rate: 8.9 }
        ]
    }
];



module.exports = {
    primeRates,
    primeRatesCtMandCkDirect
};